/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PayerContractRules } from './PayerContractRules';
import {
    PayerContractRulesFromJSON,
    PayerContractRulesFromJSONTyped,
    PayerContractRulesToJSON,
} from './PayerContractRules';

/**
 * 
 * @export
 * @interface GetPayerContractRules200Response
 */
export interface GetPayerContractRules200Response {
    /**
     * 
     * @type {PayerContractRules}
     * @memberof GetPayerContractRules200Response
     */
    data?: PayerContractRules;
}

/**
 * Check if a given object implements the GetPayerContractRules200Response interface.
 */
export function instanceOfGetPayerContractRules200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetPayerContractRules200ResponseFromJSON(json: any): GetPayerContractRules200Response {
    return GetPayerContractRules200ResponseFromJSONTyped(json, false);
}

export function GetPayerContractRules200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPayerContractRules200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PayerContractRulesFromJSON(json['data']),
    };
}

export function GetPayerContractRules200ResponseToJSON(value?: GetPayerContractRules200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PayerContractRulesToJSON(value.data),
    };
}

